import React from "react";
import "./HomeTeamView.css";
import imageAleksander from '../../assets/images/aleksander-photo.png';
import blueSkyIcon from '../../assets/svg/ic_bluesky.svg';
import imageAna from '../../assets/images/ana-photo.png';
import instagramIcon from '../../assets/svg/ic_instagram.svg';

const HomeTeamView = () => {
    return (
        <div class="team-container">
            <div class="card">
                <h1>Aleksander
                    <span class="social">
                        <a href="https://bsky.app/profile/tworca-jeden.bsky.social" target="_blank" rel="noopener noreferrer">
                            <img src={blueSkyIcon} alt="BlueSky" />
                        </a>
                    </span>
                </h1>
                <p>Experienced leader of development teams. Alchemist</p>
                <p class="team-description">I want to make you smile :)</p>
                <div class="team-icon"><img src={imageAleksander} alt="Simply, in a human way" /></div>
            </div>
            <div class="card">
                <h1>Ana
                    <span class="social">
                        <a href="https://www.instagram.com/ana_hrubalska" target="_blank" rel="noopener noreferrer">
                            <img src={instagramIcon} alt="Instagram" />
                        </a>
                    </span>
                </h1>
                <p>Visual storyteller. Creative firebrand.‎ ‎ ‎ ‎ ‎ </p>
                <p class="team-description">Simplify and coloring world &lt;3</p>
                <div class="team-icon"><img src={imageAna} alt="With ease in life" /></div>
            </div>
        </div>
    );
}

export default HomeTeamView;